import { useMemo } from "react";
import type { MatchEvent } from "../../../../store/useMatchLogStore";
import { computeMomentum } from "./computeMomentum";
import { computeRecoveryTime } from "./computeRecoveryTime";
import type {
  MomentumOptions,
  MomentumResult,
  RecoveryOptions,
  RecoveryResult,
} from "./momentumTypes";

function eventsKey(events: MatchEvent[]): string {
  const last = events.length ? events[events.length - 1].timestamp : "";
  return `${events.length}:${last}`;
}

export function useMatchMomentum(
  events: MatchEvent[],
  opts: MomentumOptions,
): MomentumResult {
  const key = eventsKey(events);
  return useMemo(
    () => computeMomentum(events, opts),
    [key, opts.homeTeamId, opts.awayTeamId],
  );
}

export function useBallRecoveryTime(
  events: MatchEvent[],
  opts: RecoveryOptions,
): RecoveryResult {
  const key = eventsKey(events);
  return useMemo(
    () => computeRecoveryTime(events, opts),
    [key, opts.homeTeamId, opts.awayTeamId],
  );
}
